/**
 * @desc 保存报告mq
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  body: Array<object>,
  params: API.platDataFlow.amzMqPush.saveBusinessMq.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/mqPush/saveBusinessMq`, {
      method: "POST",
      params,
      data: body,
      ...options,
    }),
  );
}
